import React, { type FC, memo } from "react";
import { getWeeksFromNow } from "../../../../../../../common-deprecated/utils";
import { CarConfigLabel, useCarConfigOptionalLabel } from "../../../../utils/labelUtils";

const ETA: FC<{ date: string }> = ({ date }) => {
    const noDeliveryLabel = useCarConfigOptionalLabel("carConfigNoDelivery");

    const weeksFromNow =
        date &&
        getWeeksFromNow(
            new Date(parseInt(date.substr(0, 4)), parseInt(date.substr(4, 2)) - 1, parseInt(date.substr(6, 2))),
        );

    if (weeksFromNow && date !== "19000101") {
        if (weeksFromNow <= 1) {
            return <CarConfigLabel label="carConfigDeliverySingleWeek" />;
        }
        return <CarConfigLabel label="carConfigDeliveryWeeks" params={{ weeks: weeksFromNow }} />;
    } else if (noDeliveryLabel) {
        return <CarConfigLabel label="carConfigNoDelivery" />;
    }

    return <CarConfigLabel label="carConfigDeliverySingleWeek" />;
};

export default memo(ETA);
